export default __webpack_public_path__ + "static/ski-2da7b8f0bd781cc14592dfedef10f118.webp";